module.exports = __webpack_public_path__ + "static/media/doc1.04795870.jpg";